/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import { useAppSelector, useAppDispatch } from "../../../../../redux/hook";
// import { useGetAllMediasQuery } from '../../../../redux/slices/media/apiMediaSlice';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { styled, withStyles } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { AccordionProps } from '@mui/material/Accordion';
import {  AccordionSummaryProps, } from '@mui/material/AccordionSummary';
import { Box, TextField } from '@mui/material';
import { setContentIDInUse, setContentName, setContentTags, setPrevContent } from '../../../../../redux/slices/content/contentSlice';
import Swal from 'sweetalert2';
import { useGetAllContentsQuery, useUpdateContentMutation, useUpdateContentTagMutation } from '../../../../../redux/slices/content/apiContentSlice';
import { AssociativeArray, Content, ContentInput, ContentTag, secondsToHHmmss } from '../../../../../redux/slices/content/contentModels';
import { extractContentInUse } from '../../../../../redux/slices/schedule/scheduleModels';

//----------------------------------------

type Props = {
  className?: string,
}

//----------------------------------------
const AccordionContent: React.FC<Props> = ({className}) => {
  
  const dispatch = useAppDispatch()  
  //-----------------------------------------
  const [updateContent] = useUpdateContentMutation();  
  const [updateContentTag] = useUpdateContentTagMutation();

  const { data: allContents, isLoading: isLoadingContents, isFetching} = useGetAllContentsQuery(5, { refetchOnMountOrArgChange: true })  
  const [existContentNames, setExistContentNames] = useState<string[]>([])

  const [contName, setContName] = useState<string>("")
  const [contTags, setContTags] = useState<string[]>([])

  const currPersistContent = useAppSelector(state => state.persistor._content.currContent)
  // console.log("currPersistContent: ", currPersistContent)
  // console.log("allContents: ", allContents?.filter(ct => ct.user_template_id === currPersistContent.user_template_id))

  const contentIDInUse : AssociativeArray[] = useAppSelector(state => state.persistor._content.contentIDInUse) // for just pure a list of all sched
  const status =  currPersistContent.user_template_id && Object.keys(contentIDInUse).includes(currPersistContent.user_template_id)? "active":"inactive"
  
  // ---------------------------------------
  const renameContentHandler = async () => {

    const inputValue = currPersistContent.user_template_name

    Swal.fire({
      title: 'Campaign Name',
      input: 'text',
      inputValue,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonColor: '#9C258F',
      confirmButtonText: 'Rename',
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        if (!name) {
          Swal.showValidationMessage('You need to write something!')
        }else{
          if (existContentNames.includes(name.toLowerCase()) && (currPersistContent.user_template_name && (name.toLowerCase() !== currPersistContent.user_template_name.toLowerCase()))){
            Swal.showValidationMessage('This name already exist!')
          }
        } 
      return name        
    },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        
        // currPersistContent.user_template_name = result.value
        setContName(result.value)
        dispatch(setContentName(result.value))

        // -------------------------------
        var eleList:any[] = []
        currPersistContent.elements?.map((section, index) => {
          eleList.push({
            element_id  : section.element_id,
            position_id : section.position_id,
            alias       : section.alias,
            element_setting : JSON.stringify(section.element_setting),
            type            : section.element_type,
            source_ids      : JSON.stringify(section.sources),
          })
        })

        const content: ContentInput = {
          contentId:  currPersistContent? (currPersistContent.user_template_id? currPersistContent.user_template_id:""):"",
          user_template:{
            user_template_name  : result.value,
            template_id         : currPersistContent? (currPersistContent.template_id? currPersistContent.template_id:""):"",
            duration            : currPersistContent.duration,          
            tag                 : currPersistContent.tag
          },
          elements: eleList
        }         
        updateContent(content)

        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-right',
          iconColor: 'green',
          customClass: {
            popup: 'colored-toast'
          },
          showConfirmButton: false,
          timer: 2000,
        })
        Toast.fire({
            icon: 'success',
            title: `Campaign <span class='text-primary text-capitalize'>${currPersistContent.user_template_name}</span><br/> is successfully renamed to <span class='text-primary text-capitalize'>${result.value}</span>.`,
        })
        
      }
    })        
  }

  // ---------------------------------------
  const modifyTagHandler = async () => {

    const inputValue = currPersistContent.tag? currPersistContent.tag.reduce((res, tg, ind)=> {return res+(ind ===0 ? "":", ")+tg},"") : ""

    Swal.fire({
      title: `Campaign Tags<br/><div class="fs-6 text-gray-500 mt-3">Separated by commas (e.g. tag1, tag2, tag3)</div><div class="fs-6 text-gray-500 mt-1 mb-0">Max. 10 tags/campaign</div><div class="fs-6 text-gray-500 mt-1 mb-3">Max. 50 letters/tag</div>`,
      input: 'text',
      inputPlaceholder: "Tags, separated by commas (tag1, tag2, tag3)",
      inputValue,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonColor: '#9C258F',
      confirmButtonText: 'Update Tags',
      showLoaderOnConfirm: true,
      preConfirm: (tags) => {
        
        const MAX_TAGS = 10;
        const MAX_LEN  = 50;
        if (tags && tags !== ""){          
          const arrTags: string[] = Array.from(new Set(tags.split(",")))
          if (arrTags.length <= MAX_TAGS){  
            let longTagFlag = false;
            arrTags.forEach((tg: string) => {
              if (tg.trim().length > MAX_LEN){
                longTagFlag = true;
              }
            });          
            if (longTagFlag){
              Swal.showValidationMessage(`Each tag must be less than ${MAX_LEN} characters !`)
              return false;
            }
          }else{
            Swal.showValidationMessage(`Too many tags (Total: ${arrTags.length} tags, Limit: only ${MAX_TAGS} tags/campaign)!`)
            return false;
          }
        }
        return tags        
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        try{
            const arrTags: string[] = (result.value !== "" ? Array.from(new Set(result.value.split(",").map((tg: string) => tg.trim()))) : [])
            // currPersistContent.tag = arrTags
            setContTags(arrTags)
            dispatch(setContentTags(arrTags))

            if (currPersistContent 
              && currPersistContent.user_template_name !== "" 
              && contTags
            ){
              const contentTag: ContentTag = {
                                                contentId : currPersistContent.user_template_id,
                                                tag       : arrTags,
                                            }
              // console.log(contentTag)
              
              updateContentTag(contentTag)
            }

        }catch(error){
            console.log('error', [error])
            Swal.fire(
                'Update content tag: ',
                'Unable to update content tag',
                'error'
            )
        }        

        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-right',
          iconColor: 'green',
          customClass: {
            popup: 'colored-toast'
          },
          showConfirmButton: false,
          timer: 2000,
        })
        Toast.fire({
            icon: 'success',
            title: `Campaign <span class='text-primary text-capitalize'>${currPersistContent.user_template_name}</span><br/> is successfully updated its tags. <br/><span class='text-primary text-capitalize'>${result.value}</span>.`,
        })        
      }
    })        
  }


  // ---------------------------------------
  useEffect(() => {
    setContName(currPersistContent.user_template_name)
    setContTags(currPersistContent.tag? currPersistContent.tag : [])
  }, [currPersistContent])

  // ----------------------------------------------
  useEffect(()=>{
    setExistContentNames(allContents?allContents.map((cont: Content)=> cont.user_template_name.toLowerCase()):[])
  },[allContents])
  
  //-----------------------------------------
  return (    
    <Accordion 
      // TransitionProps={{ unmountOnExit: true }}
      defaultExpanded={true}
      square={true}
      disableGutters={true}          
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className='p-3'  
        style={{backgroundColor:"#1e1e2d88"}}        
      >
        <Typography>
          <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-3 text-white me-2'/>
          <span className='text-white fw-semibold'>Description</span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        className='m-0 p-3 mh-500px overflow-auto'      
      >        
        <div className='d-flex justify-content-between'>
          <div className='text-muted'>Name: </div>
          <div className='d-flex justify-content-between text-capitalize'>
          {(currPersistContent && currPersistContent.user_template_name !== "")          
              ? <>
                  <span className='text-truncate w-125px text-end'>{currPersistContent.user_template_name}</span>
                  <a className='ms-2 tooltip-bottom' data-tooltip-content='Rename'
                    onClick={()=> renameContentHandler() }
                  ><i className='fa fa-edit'></i>
                  </a>
                </>
              : <span className='text-muted'>Untitled</span>
          }    
          </div>
        </div>
        <div className='d-flex justify-content-between text-capitalize'>
          <span className='text-muted'>Status: </span>
          {status === "active" &&
            <span className="fw-bold text-success">{status}</span>
          }
          {status === "inactive" &&
            <span className="text-muted">{status}</span>
          }          
        </div>        
        <div className='d-flex justify-content-between'>
          <span className='text-muted'>Orientation:</span>
          <span>{currPersistContent.width >= currPersistContent.height? "Landscape":"Portrait"}</span> 
        </div>
        <div className='d-flex justify-content-between'>
          <div className='text-muted'>Tags: </div>
          <div className='d-flex justify-content-between text-capitalize'>
            {(currPersistContent 
              // && currPersistContent.user_template_name !== "" 
              // && contTags
            )          
              ? <>
                  <span className='w-150px text-end'>
                    {contTags.map((tg, ind) => {
                      return <span className='badge badge-light me-1 mb-1 text-truncate' style={{maxWidth:'150px'}} key={`tag-${ind}-${tg}`} title={tg.length>30 ? tg:''}>{tg}</span>
                    })}
                  </span>
                  <a className='ms-2 tooltip-bottom' data-tooltip-content='Edit tags'
                    onClick={()=> modifyTagHandler() }
                  ><i className='fa fa-edit'></i>
                  </a>
                </>
              : <span className='text-muted'>N/A</span>
            }    
          </div>
        </div>
        {/*
        <div className='d-flex justify-content-between'>          
          <span className='text-muted'>Duration: </span>
          <span>{secondsToHHmmss(currPersistContent.duration)}</span>          
        </div>
      */}
          
        
      </AccordionDetails>
    </Accordion>
  )
}

export {AccordionContent}